/* eslint-disable react/sort-comp */
/* eslint-disable import/order */
import AppBar from '@material-ui/core/AppBar'
import Dialog from '@material-ui/core/Dialog'
import IconButton from '@material-ui/core/IconButton'
import withStyles from '@material-ui/core/styles/withStyles'
import Toolbar from '@material-ui/core/Toolbar'
import Typography from '@material-ui/core/Typography'
import CloseIcon from '@material-ui/icons/Close'
import React from 'react'
import { connect, useSelector } from 'react-redux'

import styles from '../../../resources/theme/users'
import {
  edit,
  getPermission,
  update,
  syncServiceImages,
} from '../AttendanceActions'
import Form, { ATTENDANCE_HISTORIC_SLOT_ID } from './Form'
import { bindActionCreators } from 'redux'
import { Grid, Slide } from '@material-ui/core'
import BaseCreatePage from '../../../components/hooks/BaseCreatePage'
import { mdiCalendarMultiple } from '@mdi/js'
import Icon from '@mdi/react'
import { Link } from 'react-router-dom/cjs/react-router-dom.min'
import colors from '../../../assets/colors'
import { renderRoute } from '../../../util/utils'
import Calendar from './Calendar'

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />
})

class EditAttendance extends React.PureComponent {
  constructor(props) {
    super(props)

    this.state = { attendance: null, updateOnlyServiceValue: false }
  }

  async refresh() {
    const { edit, match } = this.props
    const resp = await edit(match.params.id)
    if (resp?.code === 200) {
      const { data } = resp

      const editingAttendance = {
        ...data,
        final_value_discount: data.total_with_discount,
        services: data.services.map(_item => {
          let item = { ..._item }
          if (item?.measureType.id === 1)
            item = { ...item, quantity: parseInt(item.quantity, 10) }
          return item
        }),
      }

      this.setState({
        attendance: editingAttendance,
        updateOnlyServiceValue: !resp?.canUpdate || false,
      })
    }
  }

  componentDidMount() {
    const { match } = this.props

    if (window.Echo) {
      window.Echo.private(`Attendance.${match.params.id}`).listen(
        `AttendanceHasUpdate`,
        () => {
          document.location.reload()
        }
      )
    }
    this.refresh()
  }

  componentWillUnmount() {
    const { match } = this.props
    window.Echo?.leave(`Attendance.${match.params.id}`)
  }

  onSubmit = async (values, redirect) => {
    const { update, syncServiceImages, history } = this.props

    const data = await update(values)
    if (data?.code === 200) {
      /**
       * As fotos dos itens vão em uma segunda request. Sem `await`: a navegação
       * não espera o upload. A request segue em voo mesmo depois da troca de
       * rota (o unmount não cancela o XHR) e, se falhar, o erro aparece no
       * snackbar global.
       */
      syncServiceImages(data?.data?.id ?? values?.id, values?.services)

      if (redirect) {
        history.push(`/calendar/${data.data.id}`, { from: '/attendance' })
      } else {
        history.goBack()
      }
    }
  }

  onClose = () => {
    const { history } = this.props
    history.goBack()
  }

  render() {
    const { classes } = this.props
    const { attendance, updateOnlyServiceValue = false } = this.state

    return (
      <BaseCreatePage
        page="Atendimentos"
        path={`Editar - OS: ${attendance?.id_laundry_client}`}
        hiddenReturn
        goBack
      >
        <Grid
          container
          xs={12}
          alignContent="center"
          alignItems="center"
          justifyContent="center"
          className={classes.rowMessage}
          style={{
            padding: '8px 0',
            borderTop: '1px dashed',
            borderColor: colors.textSecondary,
            borderBottom: '1px dashed',
            borderBottomColor: colors.textSecondary,
            color: colors.textPrimary,
            fontSize: '14px',
          }}
        >
          <Grid
            item
            xs
            style={{
              display: 'flex',
              alignItems: 'center',
              height: 'auto',
              fontWeight: 'normal',
            }}
          >
            {updateOnlyServiceValue &&
              'Ordem de serviço concluída, você poderá editar apenas os valores da OS'}
            {!updateOnlyServiceValue &&
              'Utilize os campos abaixo para editar um atendimento'}
          </Grid>

          <Grid item xs="auto">
            <Grid
              container
              justifyContent="flex-end"
              alignItems="center"
              wrap="nowrap"
              style={{ gap: '16px' }}
            >
              <Grid item id={ATTENDANCE_HISTORIC_SLOT_ID} />

              {renderRoute(['read-schedule'], getPermission()) && (
                <Grid item>
                  <Calendar classes={classes} />
                </Grid>
              )}
            </Grid>
          </Grid>
        </Grid>

        <Grid container item xs={12} style={{ marginTop: '1em' }}>
          <Form
            classes={classes}
            onClose={this.onClose}
            onSubmit={this.onSubmit}
            data={attendance}
            updateOnlyServiceValue={updateOnlyServiceValue}
          />
        </Grid>
      </BaseCreatePage>
    )
  }
}

// export default withStyles(styles)(
//   React.memo(EditType, (props, nextProps) => {
//     console.log(props)
//     return true
//   })
// )

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      edit,
      update,
      syncServiceImages,
    },
    dispatch
  )

export default connect(
  null,
  mapDispatchToProps
)(withStyles(styles)(EditAttendance))
